var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25.2004C4.63921 25.2004 8.39999 21.4396 8.39999 16.8004C8.39999 12.1612 4.63921 8.40039 0 8.40039V14.2804C1.39175 14.2804 2.51998 15.4086 2.51998 16.8004C2.51998 18.1922 1.39175 19.3204 0 19.3204V25.2004Z",
    fill: "#F0F5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 11.2001C26.5646 10.7453 25.036 10.5 23.45 10.5C15.1381 10.5 8.40002 17.2382 8.40002 25.55C8.40002 26.3843 8.46792 27.2027 8.59843 28H17.9495C17.6157 27.2516 17.4301 26.4225 17.4301 25.55C17.4301 22.2253 20.1253 19.53 23.45 19.53C25.2672 19.53 26.8962 20.3351 28 21.6081V11.2001Z",
    fill: "#F0F5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.47681 0C2.17322 6.29993 7.51436 11.2 13.9999 11.2C20.4854 11.2 25.8266 6.29993 26.523 0H17.5121C16.9558 1.39455 15.5929 2.37999 13.9999 2.37999C12.4069 2.37999 11.044 1.39455 10.4876 0H1.47681Z",
    fill: "#F0F5FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErpIcon);
export default __webpack_public_path__ + "static/media/erp-icon.2db1c7546777c0eaeb6f639bafccb61c.svg";
export { ForwardRef as ReactComponent };